<template>
<div class="relative">
	<v-form v-model="valid" ref="form">
		<div class="fixed white" style="width: 100%;" id="tool-bar">
		<v-row class="ma-0" style="width: 100%;" align="center" justify="start">
			<v-col cols="12" sm="6" xs="6" md="6" lg="3" class="d-flex justify-start">
				<slot name="breadcrumbs"></slot>
			</v-col>
			<v-spacer></v-spacer>
			<v-col cols="12" sm="6" xs="6" md="6" lg="2" class="d-flex justify-end">
				<bee-btn context="warehouse" :action-name="actions.CREATE" :disabled="file_is_locked" color="addingColor" :content="$t('WarehousesPage.create-warehouse')" @click="addDialog = true"></bee-btn>
			</v-col>
			<v-dialog persistent v-model="addDialog" max-width="400px" transition="dialog-top-transition">
			<v-card>
				<v-card-title>
					{{ formTitle }}
				</v-card-title>

				<v-card-text class="pb-0">
					<v-row justify="center">
						<v-col cols="12" class="mx-5 pb-0">
							<bee-text-field context="warehouse" :action-name="actions.CREATE" v-model="row.name" :label="$t('WarehousesPage.warehouse-name')" :rules="[rules.required]"></bee-text-field>
						</v-col>
						<v-col cols="12" class="mx-5 pb-0">
							<bee-text-field context="warehouse" :action-name="actions.CREATE" v-model="row.notes" :label="$t('WarehousesPage.notes')"></bee-text-field>
						</v-col>
					</v-row>
				</v-card-text>

				<v-card-actions class="px-5">
					<v-btn color="greenDarken1" text @click="save()" :disabled="!valid">
						{{$t('WarehousesPage.save')}}
					</v-btn>
					<v-btn color="redDarken1" text @click="reset()">
						{{$t('WarehousesPage.cancel')}}
					</v-btn>
					<v-spacer></v-spacer>
				</v-card-actions>
			</v-card>
			</v-dialog>
		</v-row>
		</div>
		<div class="ma-auto absolute" id="main" style="width: 100%; height: auto">
		<v-card flat>
			<v-card-text class="pt-0 px-3">
				<bee-simple-table empty-state="dashes"
					:fixed-header="true"
					context="warehouse" :action-name="actions.CREATE"
					@delete="selectedId = $event.id; deleteDialog = true" 
					@edit=" row ={...$event}; addDialog=true"
					@inventory="goWarehouseInventory($event)"
					:configs="configs" 
					:with-color="true" :zebra="false"  
					:hide-footer="true" :headers="file_is_locked ? headers_when_file_is_locked : headers" :items="warehouses">
				</bee-simple-table>
			</v-card-text>
		</v-card>
		<bee-dialog
		    :persistent="true"
		    @handler="confirmDelete()"
		    @close="reset()"
		    v-model="deleteDialog"
		    :title="$t('WarehousesPage.delete-the-warehouse')"
		    :message="$t('WarehousesPage.are-you-sure-you-want-to-delete-the-warehouse')"
		></bee-dialog>
		</div>
	</v-form>
</div>
</template>
<script>
import rules from "../../../validation";
import { mapState } from "vuex";
import  store  from "../../../store/index.js";
import actions from "../../../permissions/actions-names.js"
export default {
data: () => ({
	actions,
	deleteDialog: false,
	addDialog: false,
	valid: false,
	selectedId: null,
	...rules,
	row: {id: null, name: null, notes: null},
}),
mounted(){
	window.observer.observe(document.querySelector("#tool-bar"))
},
methods:{
	reset(){
		Object.keys(this.row).forEach(key => this.row[key] = null)
		this.addDialog = false
		this.deleteDialog = false
		this.$refs.form.resetValidation()
	},
	save(){
		if(!this.row.id)
			this.$store.dispatch("warehouses/create", { warehouse: this.row }).then(()=>{ store.dispatch("warehouses/fetchAll") }).finally(() =>  this.reset())
		else
			this.$store.dispatch("warehouses/update", { warehouse: this.row }).then(()=>{ store.dispatch("warehouses/fetchAll") }).finally(() =>  this.reset())
	},
	confirmDelete(){
		this.$store.dispatch("warehouses/delete",{ id: this.selectedId }).then(()=>{ store.dispatch("warehouses/fetchAll") }).finally(() =>  this.selectedId = null)
	},
	goWarehouseInventory(item){
		this.$router.push({ name: 'warehouses-inventory', query: { warehouseId: item.id } })
	}
},
computed: {
	...mapState("warehouses" , ["warehouses"]),
	...mapState("configs" , ["configs"]),
	formTitle() {
		return !this.row.id
		? this.$t('WarehousesPage.create-warehouse')
		: this.$t('WarehousesPage.edit-warehouse')
	},
	headers() {
		return [
			{
				text: this.$t('WarehousesPage.headers.no'),
				value: 'warehouse_no',
				type: 'string',
				width: '10%',
				editable: true
			},
			{
				text: this.$t('WarehousesPage.headers.warehouse-name'),
				value: 'name',
				type: 'string',
				width: '30%',
				editable: true
			},
			{
				text: this.$t('WarehousesPage.headers.notes'),
				value: 'notes',
				type: 'string',
				editable: true,
				width: '40%', settings: { itemText: 'name' }
			},
			{
				text: this.$t('WarehousesPage.headers.actions'),
				value: 'actions',
				type: 'actions',
				width: '20%', actions: [
					{ name: 'edit', action_name: actions.EDIT }, 
					{ name: 'inventory', action_name: actions.GET },  
					{ name: 'delete', action_name: actions.DELETE },  
				]
			}
		]
	},
	headers_when_file_is_locked() {
		return [
			{
				text: this.$t('WarehousesPage.headers.no'),
				value: 'warehouse_no',
				type: 'string',
				width: '10%',
				editable: true
			},
			{
				text: this.$t('WarehousesPage.headers.warehouse-name'),
				value: 'name',
				type: 'string',
				width: '30%',
				editable: true
			},
			{
				text: this.$t('WarehousesPage.headers.notes'),
				value: 'notes',
				type: 'string',
				editable: true,
				width: '40%', settings: { itemText: 'name' }
			},
			{
				text: this.$t('WarehousesPage.headers.actions'),
				value: 'actions',
				type: 'actions',
				width: '20%',
				actions: [{ name: 'inventory', action_name: actions.GET },]
			}
		]
	},
	file_is_locked(){ 
        return this.configs?.financial_file?.is_locked }
},
async beforeRouteEnter(to, from, next) {
	let promises = [store.dispatch('warehouses/fetchAll')]

	let configs = JSON.parse(JSON.stringify(store.state.configs.configs))
	if(Object.keys(configs).length == 0)
		promises.push(store.dispatch('configs/fetchAll'))

	if(promises.length)
		await Promise.all(promises)
	next();
}
};
</script>
<style scoped>

</style>